<template>
    <div style="padding-top:50px;min-height:90vh;">
      <div style="padding:5px 16px;color:#CCC;font-size:75%;">分类</div>
      <MobileTicketTypePicker
        ref="TypePicker"
        v-model="ticketNew.orderType" />

      <!-- 淘金客问题反馈这个场景用户不填标题，只填内容 -->
      <template v-if="showTitle">
        <div style="padding:5px 16px 0 16px;color:#CCC;font-size:75%;">主题</div>
        <van-field style="font-size:110%;"
            v-model="ticketNew.orderTitle"
            placeholder="主题和内容不可同时为空"/>
      </template>

      <div style="padding:5px 16px 0 16px;color:#CCC;font-size:75%;">内容</div>

      <van-field
        style="font-size:110%;max-height: 65px;overflow: auto;"
        v-model="ticketNew.orderContent"
        type="textarea"
        maxlength="999"
        show-word-limit
        rows="2"
        autosize
        placeholder="描述你遇到的问题"/>

      <div style="padding:10px;">
        <MobileTicketUpload ref="up6"/>

        <MobileSubmitButton @click="newTicket_1" ref="subBtn_1">提交</MobileSubmitButton>
      </div>

      <!-- 单纯撑高一下  -->
      <div style="height:15vh;"></div>
    </div>
</template>

<script>
import { validatePlainText } from '@/assets/utils/TicketInputValidator';

export default {
    name : 'MobileTicketNew',

    props : ['showTitle', 'ticketType'],

    data () {
        return {
        ticketNew : {
            orderType : null, // 意见反馈类型固定为 999
            orderContent : ""
        }
        }
    },

    watch : {
        ticketType() {
            if( !!this.ticketType ) {
                this.ticketNew.orderType = this.ticketType;
            }
        }
    },

    created() {
        if ( !!this.$route.query.ticketType ) {
            this.ticketNew.orderType = this.$route.query.ticketType;
        } else if ( !!this.ticketType ) {
            this.ticketNew.orderType = this.ticketType;
        }
    },

    methods : {
        newTicket_1() {
            if ( !this.ticketNew.orderType ) {
                _notify('请选择反馈分类');
                return;
            }

            var titleResult = validatePlainText(this.ticketNew.orderTitle);
            var contentResult = validatePlainText(this.ticketNew.orderContent, {
                required: !titleResult.value,
                maxLength: 999,
                requiredMessage: '请描述你遇到的问题'
            });
            if ( !contentResult.valid ) {
                _notify(contentResult.message);
                return;
            }

            this.ticketNew.orderTitle = titleResult.value;
            this.ticketNew.orderContent = contentResult.value;

            // 如果未填标题，就以内容为标题
            if ( !this.ticketNew.orderTitle ) {
                this.ticketNew.orderTitle = this.ticketNew.orderContent.substring(0, 25);
            }

            this.ticketNew.attachmentList = this.$refs.up6.getAttachmentList();

            var _this = this;
            _this.$refs.subBtn_1.disable();

            _this.$http.post("/ticket/v2-workOrder/create", _this.ticketNew).then( response => {
                    _this.$refs.subBtn_1.enable();

                    if ( !!response.data.status ) { // 成功
                        _this.$refs.up6.setAttachmentList([]);

                        // _this.$router.push({path:"/ticket-vue/v"});
                        _this.$emit('ticket-created');
                        return;
                    }

                    console.log('#97 workOrder/create then', response);

                    _notify('create error ' + response.data.message);
                }, response => {
                    _this.$refs.subBtn_1.enable();

                    console.log("#22 ", response);
                }
            );
        }
    }
}
</script>

<style lang="less" scoped>
.btn-blue {
  background-color: #77A9FD;
  border: 1px solid #77A9FD;
  width: 47vw;
}
</style>


// WEBPACK FOOTER //
// src/components/mobile-ticket/MobileTicketNew.vue